import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { FontSizeProvider } from "@/contexts/ThemeContext";
import { AudienceProvider } from "@/contexts/AudienceContext";
import Layout from "@/components/Layout";
import FloatingCTA from "@/components/FloatingCTA";
import AudienceSelector from "@/components/AudienceSelector";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ConditionsPage from "@/pages/ConditionsPage";
import ConditionDetailPage from "@/pages/ConditionDetailPage";
import MedicinesPage from "@/pages/MedicinesPage";
import MedicineDetailPage from "@/pages/MedicineDetailPage";
import ContactPage from "@/pages/ContactPage";
import ResourcesPage from "@/pages/ResourcesPage";
import ArticleDetailPage from "@/pages/ArticleDetailPage";
import LocationPage from "@/pages/LocationPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <FontSizeProvider>
      <AudienceProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/conditions" element={<ConditionsPage />} />
              <Route path="/conditions/:slug" element={<ConditionDetailPage />} />
              <Route path="/medicines" element={<MedicinesPage />} />
              <Route path="/medicines/:slug" element={<MedicineDetailPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/resources" element={<ResourcesPage />} />
              <Route path="/resources/:slug" element={<ArticleDetailPage />} />
              <Route path="/location/:city" element={<LocationPage />} />
            </Routes>
          </Layout>
          <FloatingCTA />
          <AudienceSelector />
          <Toaster position="top-right" />
        </BrowserRouter>
      </AudienceProvider>
    </FontSizeProvider>
  );
}

export default App;
